import { Filter } from '../../../core/components/filter-widget/filter.type';
import { HttpParams } from '@angular/common/http';

export class FinderFilterMapper {
  public static mapParams(search: string, filter: Filter): HttpParams {
    let params: HttpParams = new HttpParams();
    // search
    if (search) {
      params = params.append('search', search);
    }
    // category
    const categoryFilter = filter['category'];
    if (categoryFilter?.value && (categoryFilter.value as { value: string }).value !== '') {
      params = params.append(
        'filter',
        'category:' + (categoryFilter.value as { value: string }).value,
      );
    }
    // countries
    const countriesFilter = filter['countries'];
    if (countriesFilter?.value) {
      (countriesFilter.value as string[]).forEach((_country) => {
        params = params.append('filter', 'country:' + _country);
      });
    }
    // tags
    const tagsFilter = filter['tags'];
    if (tagsFilter?.value) {
      (tagsFilter.value as string[]).forEach((_tag) => {
        params = params.append('filter', 'tag:' + _tag);
      });
    }
    return params;
  }
}
